export default __webpack_public_path__ + "static/media/FotoSeg10.65933eef.png";